// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"761":"19dbdcf3","787":"dc3e6b92"}[chunkId] + ".chunk.js";
};